import type { ShopperSearch } from '@/scapi';
import { createProductUrl } from './product-url';
import { getSearchHitHierarchyUrl } from './hierarchy-url';

type ProductSearchHit = ShopperSearch.schemas['ProductSearchHit'];

export const getProductListingUrl = (product: ProductSearchHit): string =>
    createProductUrl(
        product.productId,
        null,
        'color',
        (product.productType?.master || (product as { hitType?: string }).hitType === 'master') &&
            !product.productType?.bundle &&
            !product.productType?.set
            ? product.representedProduct?.id
            : null,
        getSearchHitHierarchyUrl(product)
    );
